module.exports = __webpack_public_path__ + "media/images/haircut/alexandre@2x-f4e8d259ed43a98439c213627b58b0e1.jpg";